import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	providers: {
		all: null
	}
});
